<div class="page">

  <div class="pagehead">
    <div>
      <h1>Contact us</h1>
      <p>Have a question? We'd love to hear from you</p>
    </div>
  </div>

  <div class="grid-2-1">
    <div class="card" *ngIf="Contacts; else contactSkel">
      <div class="clabel"><svg viewBox="0 0 24 24"><path d="M4 5h16v14H4z"/><path d="M4 8l8 6 8-6"/></svg>Reach us</div>
      <div class="rows" *ngFor="let contact of Contacts; let i = index">
        <div class="crow">
          <span class="cl"><i class="fa fa-map-marker" aria-hidden="true"></i>Registered address</span>
          <span class="cv">{{ contact.supportAddress1 }}</span>
        </div>
        <div class="crow" *ngIf="contact.supportAddress2">
          <span class="cl"><i class="fa fa-map-marker" aria-hidden="true"></i>Correspondence address</span>
          <span class="cv">{{ contact.supportAddress2 }}<ng-container *ngIf="contact.supportAddress3"> / {{ contact.supportAddress3 }}</ng-container></span>
        </div>
        <div class="crow">
          <span class="cl"><i class="fa fa-phone" aria-hidden="true"></i>Support mobile</span>
          <span class="cv cv--mono">{{ contact.supportNumber1 }}</span>
        </div>
        <div class="crow" *ngIf="emp_mobile">
          <span class="cl"><i class="fa fa-phone" aria-hidden="true"></i>Relationship manager</span>
          <span class="cv cv--mono">{{ emp_mobile }}</span>
        </div>
        <div class="crow" *ngIf="distibutorName">
          <span class="cl"><i class="fa fa-user-o" aria-hidden="true"></i>Your distributor</span>
          <span class="cv">{{ distibutorName }} <span class="cv--mono" *ngIf="disPhoneNumber">({{ disPhoneNumber }})</span></span>
        </div>
        <div class="crow">
          <span class="cl"><i class="fa fa-envelope-o" aria-hidden="true"></i>Support email</span>
          <span class="cv cv--mono">{{ contact.supportEmail1 }}</span>
        </div>
      </div>
    </div>
    <ng-template #contactSkel>
      <div class="card">
        <div class="er-skel er-skel--text" style="width:35%"></div>
        <div class="er-skel er-skel--text" style="width:80%;margin-top:18px" *ngFor="let i of [1,2,3,4,5]"></div>
      </div>
    </ng-template>

    <div class="card">
      <div class="clabel"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M9 10a3 3 0 116 0c0 2-3 2-3 4"/><path d="M12 17.5v.5"/></svg>Quicker than a call</div>
      <a class="quick" routerLink="/complaint">
        <span class="qt">Raise a complaint</span>
        <span class="qd">Track it and chat with support in the portal</span>
      </a>
      <a class="quick" routerLink="/device-configuration-tutorial">
        <span class="qt">Device drivers &amp; setup</span>
        <span class="qd">Biometric RD services and installation guides</span>
      </a>
      <a class="quick" routerLink="/useful-links">
        <span class="qt">Useful links</span>
        <span class="qd">Government portals and bank services</span>
      </a>
    </div>
  </div>

</div>

